<template>
  <div class="room pt-3 room_inspection">
  	<div v-if="typeof room_data_tmp !== 'undefined'">
	  	<b-container class="mt-3">
	  		<b-row>
	  			<b-col cols="12" class="text-center">
	  				<h4 class="m-0 color-green font-weight-bold">{{room_data_tmp.room.room_number}}</h4>
	  			</b-col>
	  		</b-row>
	  		<b-row class="mt-3">
				<b-col cols="12">
					<div class="form-group">
					    <label for="room_status" class="m-0">{{trans['ESTADO_DO_QUARTO']}}:</label>
					    <select class="form-control" id="room_status" v-model="room_data_tmp.room.cod_room_status">
					      	<option v-for="(item, idx) in rooms_status" :key="idx" :value="item.cod_room_status">
					      		{{item.name}}
					    	</option>
					    </select>
					  </div>
				</b-col>
			</b-row>
	  		<b-row v-if="room_data_tmp.room.cod_room_status == 3 || room_data_tmp.room.cod_room_status == 4">
	  			<b-col cols="12" class="mt-3">
					<div>
						<div>
							<label for="room-observation">{{trans['OBSERVACOES_QUARTO']}}:</label>
							<b-form-textarea
						      id="room-observation"
						      v-model="room_data_tmp.room_observation"
						      placeholder=""
						      rows="3"
						      max-rows="6"
						    ></b-form-textarea>
						</div>
					</div>
	  			</b-col>
	  		</b-row>
	  		<b-row class="mt-3 mb-3">
	  			<b-col cols="12">
	  				{{trans['AVALIACAO_GERAL']}}: <star-rating v-model="room_data_tmp.evaluation" :star-size="30"></star-rating>
	  			</b-col>
	  		</b-row>
	  		<b-row class="mt-3 mb-3" v-if="$distribution.person.is_direction == 1">
	  			<b-col cols="12">					
	  				{{trans['AVALIACAO_MANUTENCAO']}}: <star-rating v-model="room_data_tmp.maintenance_evaluation" :star-size="30"></star-rating>
	  			</b-col>
	  		</b-row>
	  		<b-row class="mt-3 mb-3" v-if="$distribution.person.is_direction == 1">
	  			<b-col cols="12">
	  				{{trans['AVALIACAO_LIMPEZA']}}: <star-rating v-model="room_data_tmp.cleaning_evaluation" :star-size="30"></star-rating>
	  			</b-col>
	  		</b-row>
	  		<b-row>
	  			<b-col cols="12" class="mt-3">
					<div>
						<div>
							<label for="inp-observation">{{trans['OBSERVACOES_INSPECAO']}}:</label>
							<b-form-textarea
						      id="inp-observation"
						      v-model="room_data_tmp.inspect_observation"
						      placeholder=""
						      rows="3"
						      max-rows="6"
						    ></b-form-textarea>
						</div>
					</div>
	  			</b-col>
	  		</b-row>
	  		<b-row>
	  			<b-col cols="12" class="mt-4">
	  				<label>
					  {{trans['INSPECIONADO']}}:
					  <input type="checkbox" v-model="room_data_tmp.inspected !== null" v-on:click="update_inspected_room"/>
					  <span></span>
					</label>
	  			</b-col>
	  		</b-row>
	  	</b-container>
	</div>
    <!-- {{room_data}} -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

import StarRating from '@/components/StarRating.vue';

export default {
  name: 'room_inspection',
  props: ['room'],
  data() {
  	return {
  		loading: false,
  		can_save: true,
        room_data_tmp: null,
  		rooms_status: JSON.parse(localStorage.getItem('rooms_status')),
  	}
  },
  components: {
  	'star-rating': StarRating
  },
  methods: {
  	get_formated_date() {
  		return this.isoLocalSimples();
  	},
    update_inspected_room: function() {
		if(this.room_data_tmp.inspected !== null) {
			this.room_data_tmp.inspected = null;
			this.room_data_tmp.inspected_by = null;
		}
		else {
			this.room_data_tmp.inspected = this.get_formated_date();
			this.room_data_tmp.inspected_by = this.$distribution.person.cod_pessoa;
		}
    },
    save: function(save) {

		if (
			(this.room_data_tmp.room.cod_room_status == 3 || this.room_data_tmp.room.cod_room_status == 4) &&
			(!this.room_data_tmp.room_observation || this.room_data_tmp.room_observation.trim() == '')
		) {
    		this.$bvToast.toast( this.trans['O_CAMPO_OBSERVACAO_E_OBRIGATORIO'] , { title: 'Erro', variant: 'danger', solid: true});
    		return;
		}

    	if(this.room_data_tmp.inspected && !this.room_data_tmp.evaluation){
    		this.$bvToast.toast( this.trans['O_CAMPO_AVALIACAO_E_OBRIGATORIO'] , { title: 'Erro', variant: 'danger', solid: true});
    		return;
    	}
		
		if( this.$distribution.person.is_direction == 1 && this.room_data_tmp.inspected && !this.room_data_tmp.maintenance_evaluation ){
			this.$bvToast.toast( this.trans['O_CAMPO_MANUTENCAO_E_OBRIGATORIO'] , { title: 'Erro', variant: 'danger', solid: true});
    		return;
		}

		if( this.$distribution.person.is_direction == 1 && this.room_data_tmp.inspected && !this.room_data_tmp.cleaning_evaluation ){
			this.$bvToast.toast( this.trans['O_CAMPO_LIMPEZA_E_OBRIGATORIO'] , { title: 'Erro', variant: 'danger', solid: true});
    		return;
		}

		// Check if internet is available, go back and warn if no internet
		if (navigator && !navigator.onLine) {
			
			this.$emit('go_to', {
                name  : 'list_rooms',
                params: {
                    cod_dist_zone: this.room_data.cod_distribution_zone,
                    elem_scroll  : "room_" + this.room_data.room.room_number
                }
            });
			
			setTimeout(() => {
				this.$bvToast.toast(this.trans['INSPECTION_NOT_SAVED_NO_INTERNET'], { title: 'Erro', variant: 'danger', solid: true });
			}, "1000");

			return;
		}

        if(save) {
            let previous_room_status = this.room_data.room.cod_room_status;
			this.$emit('set_loading', true);

			if( this.$distribution.person.is_direction == 1 ){			
            	this.room_data.maintenance_evaluation = this.room_data_tmp.maintenance_evaluation;
            	this.room_data.cleaning_evaluation    = this.room_data_tmp.cleaning_evaluation;
			}

			if( (this.room_data_tmp.room.cod_room_status == 3 || this.room_data_tmp.room.cod_room_status == 4) ){
				this.room_data.room_observation = this.room_data_tmp.room_observation
			}

            this.room_data.room                		 = JSON.parse(JSON.stringify(this.room_data_tmp.room));
            this.room_data.room.previous_room_status = previous_room_status;
            this.room_data.evaluation          		 = this.room_data_tmp.evaluation;
            this.room_data.inspect_observation 		 = this.room_data_tmp.inspect_observation;
            this.room_data.inspected           		 = this.room_data_tmp.inspected;
            this.room_data.inspected_by        	 	 = this.room_data_tmp.inspected_by;
            this.room_data.saved               		 = 0;
        
            this.$emit('go_to', {
                name  : 'list_rooms',
                params: {
                    cod_dist_zone: this.room_data.cod_distribution_zone,
                    elem_scroll  : "room_" + this.room_data.room.room_number,
					search_hotel: this.$route.params.search_hotel,
					search_bloco: this.$route.params.search_bloco,
					search_piso: this.$route.params.search_piso,
					search_n_quarto: this.$route.params.search_n_quarto
                }
            });
        } else {
            this.room_data_tmp = JSON.parse(JSON.stringify(this.room_data));
        }
    },
  	send_data: function(items) {
  		if(items.length > 0 && this.can_save) {
  			this.can_save = false;
			this.$http.post('housekeeping/update_rooms?token=' +this.$distribution.person.token,
				{
					rooms: items
				},
				{
					before(request) {
				}
			})
			.then(resp => {
				for(var r of resp.body.rooms) {
		            for(var z of this.$distribution.zones) {
		              var r_idx = z.rooms.findIndex((item, idx) => item.cod_distribution_room == r.cod_distribution_room);
		              if(r_idx !== -1) {
		              	this.$set(z.rooms, r_idx, r);
		              }
		            }
		        }
			}, resp => {

			}).then(resp => {
				this.can_save = true;
			});
		}
  	}
  },
  computed: {
  	room_data: function() {
  		if(typeof this.room !== 'undefined') { // check if we can use prop sent by router link
  			return this.room;
  		}
  		let zone = this.get_zone();
  		if(typeof zone !== 'undefined') {
  			let room = this.get_room(zone);
  			if(typeof room !== 'undefined') {
  				return room;
  			}
  		}
  	},
  	total_items: function() {
  		return this.room_data_tmp.room.espaco.hk_item_prices.reduce((current_sum, item) => current_sum + parseInt(item.quantity), 0);
  	},
  	total_items_consumed: function() {
  		return this.room_data_tmp.room.espaco.hk_item_prices.reduce((current_sum, item) => current_sum + parseInt(item.consumed), 0);
  	}
  },
  watch: {
  },
  created: function() {
  	if(typeof this.room_data === 'undefined') {
		this.$router.push({name: 'login', params: {lang: this.$route.params.lang}});
		return;
	}
	this.room_data_tmp = JSON.parse(JSON.stringify(this.room_data));

	if( this.room_data_tmp.room.blocked_observations ){
	 		this.room_data_tmp.room_observation = this.room_data_tmp.room.blocked_observations.blocked_reason;
	}
  }
}
</script>
<style>
	.footer {
		bottom: 0;
		left: 0;
		right: 0;
	}
</style>
<style scoped>
	input {
	  display: none;
	}

	label input[type=checkbox] ~ span {
	  display: inline-block;
	  vertical-align: middle;
	  cursor: pointer;
	  background: #fff;
	  border: 1px solid #888;
	  padding: 1px;
	  height: 20px;
	  width: 20px;
	}

	label input[type=checkbox]:checked ~ span {
	  /* image: Picol.org, cc-by 3.0, https://commons.wikimedia.org/wiki/File:Accept_Picol_icon.svg */
	  background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M14 18L26 6l4 4-16 16L4 16l4-4z"/></svg>');
	  background-size: 100%;
	}
</style>